import * as React from "react";
import { FC } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import theme from "styles/theme";

interface IProps {
    className?: string;
}

export const SpinLeftIcon: FC<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 14 14" stroke={theme.palette.darkGrey} {...props}>
            <g fill="none" fillRule="evenodd">
                <polyline
                    id="Path"
                    stroke="inherit"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    points="11 7 13 9 11 11"
                />
                <path
                    d="M3.033,3.321 C2.378,3.832 2,4.399 2,5 C2,7.209 6.925,9 13,9 L11,7"
                    id="Path"
                    stroke="inherit"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </SvgIcon>
    );
};

export default SpinLeftIcon;
